import bem from 'utils/bem';

export const block = bem('fake-feature-modal');
